import React from 'react';
import './PerkHistory.scss';
import { HistoryCarousel, HistoryCarouselMobile } from './components';
import { PageSectionPB } from '../../PricingBenefits/shared';
export var PerkHistory = function (_a) {
    var isMobile = _a.isMobile;
    var currentYear = new Date().getFullYear();
    return (React.createElement("div", { className: "PerkHistory__MobileContainer" },
        React.createElement(PageSectionPB, { title: "".concat(currentYear, " Perk History") }, isMobile ? React.createElement(HistoryCarouselMobile, null) : React.createElement(HistoryCarousel, null))));
};
